export default {
  name: 'SettingItem',
  props: ['title']
};